import { IncomingMessage } from 'http';

import { fechFromBPartsApi } from '../utils';

const fetchLastVehicles = async (
  {
    locale,
    carIdentifier,
    partIdentifier,
    categoryIdentifier,
    pageIdentifier,
  }: {
    locale: string;
    partIdentifier?: string;
    carIdentifier?: string;
    pageIdentifier?: string;
    categoryIdentifier?: string;
  },
  req?: IncomingMessage
) => {
  const query = [];
  if (carIdentifier) {
    query.push(`car_identifier=${encodeURI(carIdentifier)}`);
  }

  if (partIdentifier) {
    query.push(`part_identifier=${encodeURI(partIdentifier)}`);
  }

  if (categoryIdentifier) {
    query.push(`category_identifier=${encodeURI(categoryIdentifier)}`);
  }

  if (pageIdentifier) {
    query.push(`page_identifier=${encodeURI(pageIdentifier)}`);
  }

  const data = await fechFromBPartsApi(
    `/${locale}/shop/vehicles/last_entries?${query.join('&')}`,
    {
      credentials: 'include',
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
    }
  );

  if (data.ok) {
    return data.json();
  } else {
    return null;
  }
};

export default fetchLastVehicles;
